import type { CurrentPlatform } from "@/partner/entities/platforms";

export function mapPlatformToSocialFormValues(
  platform: CurrentPlatform | null | undefined
): Record<string, any> {
  if (!platform) {
    return {
      footer: {
        title: "",
        subtitle: "",
        social: [],
      },
    };
  }

  return {
    footer: {
      // title/subtitle are not editable on this screen, but must be carried
      // through so submit doesn't wipe them: mongoose $set replaces the
      // whole nested `footer` object rather than merging sub-fields.
      title: platform.footer?.title || "",
      subtitle: platform.footer?.subtitle || "",
      social:
        platform.footer?.social?.map((item) => ({
          type: item.type,
          link: item.link,
        })) || [],
    },
  };
}
